var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cv-tab",attrs:{"id":_vm.uid,"role":"tabpanel","aria-labelledby":(_vm.uid + "-link"),"aria-hidden":!_vm.dataSelected ? 'true' : 'false',"hidden":!_vm.dataSelected}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }